import React from 'react';
import Lozenge from '@atlaskit/lozenge';

import { flexCenter, spaceGapTiny, tableHeadStyles } from '@/styles';
import { DateDisplayFormats } from '@/constants';
import { formatDateForDisplay } from '@/utils';
import { ExternalLinkAction } from '@/components/primitive';

import SfxIcon from '../sfx-icon';

interface Detector {
  detectorId: string;
  isCentralMonitoringDetector: boolean;
  alertType: string;
  status: string;
  detectorUpdatedTimestamp: string;
  detectorCreatedTimestamp: string;
  detectorVersion: string;
}

interface DetectorsTableProps {
  detectors: Detector[];
  title?: string;
}

const DetectorsTable: React.FC<DetectorsTableProps> = ({ detectors, title }) => (
  <div>
    {title && <h4>{title}</h4>}
    <table>
      <thead css={tableHeadStyles}>
        <tr>
          <th>Detector ID</th>
          <th>Alert Type</th>
          <th>Status</th>
          <th>Recipient</th>
          <th>Created At (UTC)</th>
          <th>Updated At (UTC)</th>
          <th>Version</th>
          <th css={[flexCenter, spaceGapTiny]}>
            <SfxIcon />
            <span>Link</span>
          </th>
        </tr>
      </thead>
      <tbody>
        {detectors.map(detector => {
          const {
            detectorId,
            alertType,
            status,
            detectorUpdatedTimestamp,
            detectorCreatedTimestamp,
            detectorVersion,
            isCentralMonitoringDetector,
          } = detector;
          return (
            <tr key={detectorId + alertType}>
              <td>{detectorId}</td>
              <td>
                <Lozenge appearance="default" isBold={false}>
                  {alertType}
                  {alertType === 'BREACH' ? '' : ' burn'}
                </Lozenge>
              </td>
              <td>
                <Lozenge appearance={status === 'HEALTHY' ? 'success' : 'default'} isBold={false}>
                  {status}
                </Lozenge>
              </td>
              <td>
                <Lozenge appearance="default" isBold={false}>
                  {isCentralMonitoringDetector ? 'Central Monitoring' : 'Owning Team'}
                </Lozenge>
              </td>
              <td>
                <code>
                  {formatDateForDisplay(
                    detectorCreatedTimestamp,
                    DateDisplayFormats.TIME_WITH_NUMERIC_DATE
                  )}
                </code>
              </td>
              <td>
                <code>
                  {formatDateForDisplay(
                    detectorUpdatedTimestamp,
                    DateDisplayFormats.TIME_WITH_NUMERIC_DATE
                  )}
                </code>
              </td>
              <td>{detectorVersion}</td>
              <td>
                <ExternalLinkAction
                  text="View"
                  href={`https://atlassian.signalfx.com/#/detector/v2/${detectorId}/edit`}
                />
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  </div>
);

export default DetectorsTable;
